import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Widget_event_bindings_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="widget_event_bindings" />;
  }
}
